export default __webpack_public_path__ + "static/media/institute-7-min.c39f419e.webp";